import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import Navbar from './components/Navbar';
import Header from './components/Header';
import AboutUs from './components/AboutUs';
import Footer from './components/Footer';
import Activities from "./components/Activities";
import ContactForm from "./components/ContactForm";
import WhatsAppButton from './components/WhatsAppButton';
import './App.css';

function App() {
    return (
        <div className="main-container">
            <Navbar />

            <AnimatePresence>
                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 1 }}
                >
                    <Header />

                    <main className="content-layout">
                        <AboutUs />
                        <Activities />
                        <ContactForm />
                    </main>

                    <Footer />
                </motion.div>
            </AnimatePresence>

            <WhatsAppButton />
        </div>
    );
}

export default App;